function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { TagItem } from '@fluentui/react';
import { getFilterType } from 'utils/filterHelpers';
import SpzaComponent from './spzaComponent';
import { Constants } from '@shared/utils/constants';
import { urlPush } from '@shared/routerHistory';
import { handleFilterToggle } from '@shared/utils/filterItemUtils';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { getNpsModule } from '@appsource/utils/nps';
import { listOfUrlKeysToExcludeInAppsource } from '@shared/oneTaxonomy';
const tagItemStyles = {
    close: {
        '&:focus': {
            border: '2px solid'
        }
    }
};
class GalleryHeader extends SpzaComponent {
    componentDidMount() {
        this.setState({
            isMounted: true
        });
    }
    getRoute() {
        return getEntityRegistration(this.props.entityType).route;
    }
    removeSearchFilter() {
        if (!this.props.isEmbedded) {
            const newPath = this.context.buildHref(this.getRoute(), null, {
                search: null,
                page: null,
                sortBy: null
            });
            urlPush(newPath);
        }
    }
    renderImpl() {
        if (!this.state.isMounted) {
            return null;
        }
        const headerFilters = [];
        let isConsultingSevices = false;
        const route = this.getRoute();
        if (route) {
            isConsultingSevices = route.getPath(null) && route.getPath(null).indexOf('consulting-services') > -1 || false;
        }
        this.props.activeFilters.forEach((filter)=>{
            let filterTitleName = this.context.loc(filter.LocKey || filter.locKey, filter.Title || filter.title);
            // !!! Temporary HACK: If filterTitleName is 'Power BI apps' and we are in consulting services tab,
            // then we make the text 'Power BI'.
            if (isConsultingSevices && filterTitleName === 'Power BI apps') {
                filterTitleName = 'Power BI';
            }
            if (filter.UrlKey && !listOfUrlKeysToExcludeInAppsource.filter((item)=>item !== 'azure').includes(filter.UrlKey)) {
                const filterType = getFilterType(filter);
                headerFilters.push({
                    filterType: filterType,
                    filterValue: filter.UrlKey || filter.urlKey,
                    filterTileName: filterTitleName,
                    firstLevelProductFilter: filterType === 'product' && !filter.IsChildFilter,
                    onClick: handleFilterToggle(filterType, filter.UrlKey || filter.urlKey, true, this.props.getFilterLink(filter, filterType === 'product' && !filter.IsChildFilter ? this.props.urlQuery : null), Constants.Telemetry.ActionModifier.FilterTag, ()=>{
                        window.scrollTo(0, 0);
                    })
                });
            }
        });
        // sort function to put the subcategories after the category
        function sortFunction(a) {
            if (a.filterType === 'subcategories') {
                return 1;
            } else {
                return -1;
            }
        }
        headerFilters.sort(sortFunction);
        if (this.props.isEmbedded) {
            return null;
        }
        // TODO: the close icon should be using a sprite instead of an img
        if (headerFilters && headerFilters.length > 0) {
            return /*#__PURE__*/ _jsx("div", {
                className: "galleryHeader",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "galleryHeader_tileFilters",
                    role: "list",
                    children: headerFilters.map((filter, key)=>{
                        return /*#__PURE__*/ _jsx(TagItem, {
                            className: "tileFilter",
                            index: key,
                            item: {
                                name: `remove ${filter.filterValue}`,
                                key
                            },
                            styles: tagItemStyles,
                            tabIndex: 0,
                            onRemoveItem: ()=>{
                                var _getNpsModule;
                                filter.onClick();
                                (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter('filterActionsCount');
                            },
                            removeButtonAriaLabel: `Remove ${filter.filterTileName}`,
                            children: filter.filterTileName
                        }, key);
                    })
                })
            });
        } else {
            // In case of no headers the tile header should align with the filters hence the div with just margin.
            return /*#__PURE__*/ _jsx("div", {
                className: "emptyGalleryHeader"
            });
        }
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "state", {
            isMounted: false
        });
    }
}
export { GalleryHeader as default };
GalleryHeader.contextTypes = {
    loc: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
